












import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { MenuPane } from "../../../../panes";
import { ModelEditableMixin } from "../../../../system/mixins";

@Component({
  components: {
    MenuPane,
  }
})
export default class FreeInputSelector extends Mixins(ModelEditableMixin) {
  data() {
    return {
      isChecked: false,
    };
  }
  isChecked: boolean;

  mounted() {
    this.isChecked = this.editingSource;
  }
  
  @Prop({ default: true })
  isEnable: boolean;

  @Prop({ default: false })
  isHorizontal: boolean;

  get isVisible(): boolean {
    return this.$configuration.behavior.document.editor.contents.edit.selector.freeInputSelector.isEnable;
  }

  /**
   * 当初はeditingSourceをv-modelで指定していたが、リッチの初期化処理でオブジェクトが更新されるイベントと競合して反映しないケースがあり、
   * 対策案をいくつか試したところ、Watch経由であれば発生しない（頻度が少ない？）ことが分かった
   * おそらくリッチの初期化中はWatchの発火が遅れるなどの副作用により競合が回避できている
   */
  @Watch("isChecked")
  isCheckedUpdated(newValue: boolean, oldValue: boolean) {
    if (this.editingSource === newValue) { return; }
    this.editingSource = newValue;
  }

  @Watch("editingSource")
  isEditingSourceUpdated(newValue: boolean, oldValue: boolean) {
    if (this.isChecked === newValue) { return; }
    this.isChecked = newValue;
  }
}
